var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#e45683;}\n\t.st1{fill:#e45683;}\n")), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    style: {
      fill: "#e45683"
    },
    cx: 500,
    cy: 500,
    r: 500
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "870.3,44.8 870.3,163.7 983.6,163.7 983.6,259.8 870.3,259.8 870.3,382.6 768.5,382.6 768.5,259.8  645.7,259.8 645.7,163.7 768.5,163.7 768.5,44.8 870.3,44.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M821.2,406.6h-52.7h-24v-24v-98.8h-98.8h-24v-24v-69.6c-68.6-27.6-139.1-32.4-211.5-15.4 c0-7.2-0.1-126.7-0.1-126.7S235.4,48,148,48c0,1.3,0,2.4,0,3.5c0,153.3,0,306.5,0,459.8c0,12.4,0.7,24.7,2.1,37 c2.3,20.4,6.3,40.5,12.4,60.2c26.1,84,76.5,149.3,151.3,195.6c27.1,16.8,56.3,28.8,86.8,37.7c39.8,11.7,79.6,23.5,119.3,35.3 c28.5,8.4,57,16.9,85.4,25.3c0.9,0.3,1.8,0.5,2.9,0.7c0-176.7,0-353.2,0-529.7c-66.1-19.6-132.1-39.1-197.9-58.5c0-1.4,0-2.5,0-3.5 c5-0.5,278.2-0.3,280,0.2c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0,159.3,0,318.6,0,477.9c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2 c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1c109.8-75.5,175.1-223.5,133.2-374.1C823.3,413.3,822.3,409.9,821.2,406.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRoom);
export default __webpack_public_path__ + "static/media/add_room.5a2994dc.svg";
export { ForwardRef as ReactComponent };